/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Box, Typography } from "@mui/material";
import React from "react";

import Checkbox from "../../../../../components/Checkbox";
import TestIds from "../../../../../testIds";
import { TFOQuoteOfferScreenProps } from "../types";

interface RestrictedCheckboxProps {
  restricted: boolean;
  setRestricted: TFOQuoteOfferScreenProps["setRestricted"];
}

export const RestrictedCheckbox: React.FC<RestrictedCheckboxProps> = ({
  restricted,
  setRestricted,
}) => {
  return (
    <Box
      sx={{
        "@media (max-width: 744px)": {
          marginLeft: 0,
        },
      }}
    >
      <Checkbox
        checked={restricted}
        sx={{
          ".MuiCheckbox-root": {
            marginTop: "-8px",
            justifyContent: "flex-start",
            alignContent: "flex-start",
            alignSelf: "flex-start",
          },
        }}
        label={
          <Typography variant="body2" fontWeight={700} sx={{ paddingLeft: "12px" }}>
            Restricted editing
            <br />
            <Typography sx={{ pt: "12px" }} variant="body2" component="span" color={colors.grey800}>
              Limit shareholder to&nbsp;
              <Typography variant="body2" component="span" fontWeight={700} color={colors.grey800}>
                only increase
              </Typography>
              &nbsp;the quantity of products (they won&apos;t be able to remove products).
            </Typography>
          </Typography>
        }
        onChange={(_, checked) => setRestricted(checked)}
        data-testid={TestIds.feat.quotes.sendOffer.lock}
      />
    </Box>
  );
};
